import { get } from "app/utils/axios/kheti";
import User from "../models/user";

export const fetchUserDetails = () => get<User>('/user/v1/details')